export enum HttpErrorCodeEnum {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404
}

export type HttpErrorCodesEnumType = keyof typeof HttpErrorCodeEnum;
